import PlainDate from '@Domain/PlainDate';

const longDateFormatter = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long' });

/**
 * Renders a calendar date (`AAAA-MM-JJ`) through `PlainDate`'s own local year/month/day components,
 * never through `new Date(isoString)` on the raw string — a time zone shift would move the day.
 * Falls back to the raw string if it fails to parse, rather than throwing.
 */
const formatLongCalendarDate = (value: string | Date): string => {
	const plainDate = value instanceof Date ? PlainDate.fromCalendar(value) : PlainDate.fromApi(value);

	if (plainDate === null) {
		if (value instanceof Date) {
			// If the value is a Date object, we can format it directly
			return longDateFormatter.format(value);
		}

		return value; // Return the original string if parsing fails
	}

	return longDateFormatter.format(plainDate.toCalendar());
};

export { formatLongCalendarDate };
